// extracted by mini-css-extract-plugin
export default {"VoucherSection":"styles_VoucherSection__3MOKC","title":"styles_title__BFFyO"};